import React, { useEffect } from 'react';
import { useNavigate, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { UserRoles } from 'src/latest/src/constants';
import { superAdminRoutes } from 'src/latest/src/routes';
import './SuperAdminDashboard.scss';

export const SuperAdminDashboard: React.FC = () => {
  const navigate = useNavigate();
  const { loggedInUser } = useSelector((state: any) => state.authentication);

  useEffect(() => {
    const role = loggedInUser?.userRole?.toUpperCase();

    switch (role) {
      case UserRoles.TENANT_SUPER_ADMIN:
        break;

      case UserRoles.CLIENT:
        navigate('/therapy/client', { replace: true });
        break;

      case UserRoles.THERAPIST:
        navigate('/therapy/therapist', { replace: true });
        break;

      case UserRoles.PRACTICE_ADMIN:
        navigate('/practice-admin', { replace: true });
        break;

      case UserRoles.SCHEDULER:
        navigate('/therapy/scheduler', { replace: true });
        break;

      default:
        navigate('/', { replace: true });
        break;
    }
  }, [loggedInUser, navigate]);

  return (
    <div className="super-admin-dashboard">
      <Routes>
        <Route index={true} element={<Navigate to="home" replace={true} />} />

        {superAdminRoutes?.map(route => (
          <Route
            path={route.path}
            element={
              <div className="super-admin-dashboard-content-container">
                <route.component />
              </div>
            }
            key={route.path}
          />
        ))}
      </Routes>
    </div>
  );
};
